<template>
    <div
        v-if="type === 'determined'"
        class="ob1-spinner-determined"
        data-ob1-component="SpinnerDetermined"
        :data-spinnerdetermined-timer="timer"
        role="status"
    >
        <p class="visually-hidden">
            Chargement en cours...
        </p>
    </div>
    <div v-else>
        <svg
            class="ob1-spinner-undetermined"
            viewBox="0 0 50 50"
            :style="`width:${sizeWithUnit}; height:${sizeWithUnit}`"
            focusable="false"
            aria-hidden="true"
        >
            <circle
                class="ob1-spinner-undetermined-circle"
                cx="25"
                cy="25"
                r="20"
            />
        </svg>
        <p class="visually-hidden">
            Chargement en cours...
        </p>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    props: {
        type: {
            type: String,
            default: "determined"
        },
        timer: {
            type: Number,
            default: 6
        },
        size: {
            type: Number,
            default: 25
        }
    },
    computed: {
        sizeWithUnit() {
            return `${this.size}px`;
        }
    }
});
</script>
